import { StrictFilters } from "../hooks/useTasksOverview";

export const getTasksEndpointUrl = (
  filters: StrictFilters & { state: string; pageAfter: string }
) => {
  let url = `tasks?`;
  for (const key in filters) {
    let value = filters[key as keyof StrictFilters];

    if (!value) {
      continue;
    }

    if (Array.isArray(value)) {
      value = value.join(",");
    }
    if (value !== undefined) {
      url += `${key}=${encodeURIComponent(value)}&`;
    }
  }
  return url;
};
